
    <!--
 * 竖版-游戏logo
 * @LastEditTime: Mon Dec 23 2024 22:00:18 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_O3DB66"  :class="[`normal`,`u_c_O3DB66`]" ></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{},"ja-JP":{}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['ja-JP']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '游戏logo';

    // 自定义setup - 开始
    ;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_O3DB66.normal{
position:absolute;
width:2.28rem;
height:1.63rem;
top:0.20rem;
left:0.63rem;
background-repeat:no-repeat;
background-size:contain;
background-position:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710821285835-40.png);

}
}.ja-JP{
.u_c_O3DB66.normal{
position:absolute;
width:2.28rem;
height:1.63rem;
top:0.20rem;
left:0.63rem;
background-repeat:no-repeat;
background-size:contain;
background-position:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724379257063-21.png);

}
}
</style>
